

export const BILL_DELETE_SUMMARY_REPORT_GO_BUTTON_API = ' BILL_DELETE_SUMMARY_REPORT_GO_BUTTON_API'

export const BILL_DELETE_SUMMARY_REPORT_GO_BUTTON_API_SUCCESS = ' BILL_DELETE_SUMMARY_REPORT_GO_BUTTON_API-SUCCESS'

export const BILL_DELETE_SUMMARY_REPORT_API_ERROR_ACTION = ' BILL_DELETE_SUMMARY_REPORT_GO_BUTTON_API'
